const messages = {
  "title": "Dobrodošli u BRIDGESTONE <span class='text-danger'>PLUS</span>",
  "description": "<b>Već imate nalog?</b><br/>Prijavite se sa vašom email adresom i lozinkom.<br/><br/><b>Novi ste ovde?</b><br/>Ako ste novi korisnik, molimo registrujte se.<br/><br/>",
  "info": "",
  "buttons": {
    "action": "Prijavite se / Registrujte se",
    "back": "Nazad na prijavu",
    "changeLanguage": "Promenite jezik",
    "start": "Počnite"
  },
  "languageSelect": {
    "label": "Izbor jezika",
    "description": "Molimo izaberite vaš jezik"
  }
}

export default {
  messages
}
